import { toast as showToast } from 'sonner';

import { type Toast } from '../toast';

/**
 * Shows a sonner toast of the given type (`message`, `success`, or
 * `error`), using the toast's title, id, and description. The imperative
 * counterpart to {@link useToast}; it needs an {@link EpicToaster}
 * mounted in the tree to render.
 *
 * @param options Toast to show, matching {@link ToastSchema} output.
 * @returns The id sonner assigns to the shown toast.
 */
export const toast = (options: Toast) =>
  showToast[options.type](options.title, {
    id: options.id,
    description: options.description,
  });
